import * as React from 'react';
import ReactDOM from 'react-dom';
import clsx from 'clsx';
import { Transition, CSSTransition } from 'react-transition-group';
import { Panel, IPanelProps } from 'components';
import { ROOT_RENDER_ID } from 'project-constants';

import './style.scss';

export interface ISlideUpPanelProps extends IPanelProps {
    open: boolean;
    /**
     * В настоящее время не несет никаких изменений в видимое поведение панелей
     * потому что по умолчанию в новом дизайне они все разворачиваются на полный экран
     * @deprecated
     */
    fullscreen?: boolean;
}
export interface ISlideUpPanelState {}

class SlideUpPanelComponent extends React.Component<ISlideUpPanelProps, ISlideUpPanelState> {
    constructor(props: ISlideUpPanelProps) {
        super(props);
    }

    render() {
        let {
            open,
            fullscreen = false,
            className,
            ...restPanelProps
        } = this.props;

        if (open === false) {
            return null;
        }

        return ReactDOM.createPortal(
            <CSSTransition
                in={open}
                timeout={100}
                appear
                classNames='animation-state'
            >
                <Panel
                    className={clsx('mobile-ui-slide-up-panel', className, {
                        'fullscreen': fullscreen
                    })}
                    {...restPanelProps}
                />
            </CSSTransition>,
            document.getElementById(ROOT_RENDER_ID)
        );
    }
}

export const SlideUpPanel = SlideUpPanelComponent;
